// extracted by mini-css-extract-plugin
export default {"link":"gN-z","disabled":"hN-z"};